import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { AccountsListComponent } from '../accounts/accounts-list/accounts-list.component';
import { AttachmentPointsListComponent } from '../attachmentpoints/attachmentpoints-list/attachmentpoints-list.component';
import { BikesListComponent } from '../bikes/bikes-list/bikes-list.component';
import { BreakdownsListComponent } from '../breakdowns/breakdowns-list/breakdowns-list.component';
import { GroupsListComponent } from '../groups/groups-list/groups-list.component';
import { LocksListComponent } from '../locks/locks-list/locks-list.component';
import { StationsListComponent } from '../stations/stations-list/stations-list.component';
import { SubscriptionPlansListComponent } from '../subscriptionplans/subscriptionplans-list/subscriptionplans-list.component';
import { AuthGuardService } from '../services/auth-guard.service';
import { environment } from '../../environments/environment';
import { TripsListComponent } from '../trips/trips-list/trips-list.component';
import { AuthGuardSuperAdminService } from '../services/auth-guard-super-admin.service';
import { AuthGuardAdminService } from '../services/auth-guard-admin.service';
import { UnauthorizedComponent } from '../errors/unauthorized/unauthorized.component';
import { AuthGuardErrorService } from '../auth-guard-error.service';
import { PaymentListComponent } from '../payment/payment-list/payment-list.component';

const routes: Routes = [
  { path: 'unauthorized', component: UnauthorizedComponent, canActivate: [AuthGuardErrorService] },
  {
    path: '', canActivate: [AuthGuardService], data: { roles: environment.roles }, children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'accounts', component: AccountsListComponent, canActivate: [AuthGuardAdminService] },
      { path: 'groups', component: GroupsListComponent, canActivate: [AuthGuardSuperAdminService] },
      { path: 'subscriptionplans', component: SubscriptionPlansListComponent, canActivate: [AuthGuardAdminService] },
      { path: 'bikes', component: BikesListComponent },
      { path: 'stations', component: StationsListComponent },
      { path: 'attachmentpoints', component: AttachmentPointsListComponent, canActivate: [AuthGuardAdminService] },
      { path: 'locks', component: LocksListComponent, canActivate: [AuthGuardAdminService] },
      { path: 'breakdowns', component: BreakdownsListComponent },
      { path: 'trips', component: TripsListComponent, canActivate: [AuthGuardAdminService] },
      { path: 'payment', component: PaymentListComponent, canActivate: [AuthGuardAdminService] },
      { path: '**', redirectTo: 'dashboard' }

    ]
  },
  { path: '**', redirectTo: 'dashboard' }

];

@NgModule({
  exports: [RouterModule],
  imports: [
    RouterModule.forRoot(routes),
    CommonModule
  ],
  declarations: []
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing/app-routing.module.ts